import { ExternalLink, RefreshCw } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogPanel, DialogTitle } from "@/components/ui/dialog";

import type { ClaimWithRelations } from "../../api/use-claim";
import { ClaimDocuments } from "../claim-documents";
import { GenerateLegalSubpoena } from "./generate-legal-subpoena";

/** Port of states-cta/RegenerateLegalSubpoenaCTA.vue — assignation déjà générée. */
export function RegenerateLegalSubpoenaCTA({ claim }: { claim: ClaimWithRelations }) {
  const [showRegenerateModal, setShowRegenerateModal] = useState(false);

  const legalSubpoena = claim.legalSubpoena;

  function openLegalSubpoena() {
    if (legalSubpoena?.docxFile?.boxFileId) {
      window.open(`https://upclaim.app.box.com/file/${legalSubpoena.docxFile.boxFileId}`, "_blank");
    } else if (legalSubpoena?.boxFolderId) {
      window.open(`https://upclaim.app.box.com/folder/${legalSubpoena.boxFolderId}`, "_blank");
    }
  }

  return (
    <div className="border-b bg-slate-50">
      <div className="mx-auto max-w-lg py-5 text-left">
        <div className="rounded-md border bg-white p-8 shadow">
          <h2 className="text-base leading-6 font-semibold text-gray-900">Assignation générée</h2>
          <p className="mt-2 text-sm text-gray-500">L'assignation a déjà été générée pour ce dossier.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            {legalSubpoena?.docxFile?.boxFileId || legalSubpoena?.boxFolderId ? (
              <Button onClick={openLegalSubpoena}>
                <ExternalLink />
                Voir l'assignation
              </Button>
            ) : null}
            <Button variant="destructive" onClick={() => setShowRegenerateModal(true)}>
              <RefreshCw />
              Ré-générer l'assignation
            </Button>
          </div>
        </div>
      </div>

      <Dialog open={showRegenerateModal} onOpenChange={setShowRegenerateModal}>
        <DialogContent className="sm:max-w-4xl">
          <DialogHeader>
            <DialogTitle>Ré-générer l'assignation</DialogTitle>
          </DialogHeader>
          {showRegenerateModal ? (
            <DialogPanel>
              {/*
                The claim's real subpoena, not null: the review view then shows the
                stored numbering to rearrange before regenerating, and offers Save —
                there is a `legal_subpoenas` row to attach an arrangement to.
              */}
              <GenerateLegalSubpoena claim={claim} legalSubpoena={legalSubpoena ?? null} />
              <div className="mt-4">
                <ClaimDocuments claim={claim} />
              </div>
            </DialogPanel>
          ) : null}
        </DialogContent>
      </Dialog>
    </div>
  );
}
